import React from "react";
import { useT } from "../containers/i18n-container";

export const Tra = ({ code }: { code: string }) => {
  const { t } = useT();
  return React.createElement("span", {
    dangerouslySetInnerHTML: { __html: t(code) }
  });
};
